// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
p {
  margin-bottom: 24px;
  line-height: 1.9;
}

#title-container {
  min-height: 460px;
  height: 100%;
  color: #fff;
  background-color: var(--bs-primary); 
  text-align: center;
  padding: 105px 28px 28px 28px;
  box-sizing: border-box;
  position: relative;
  box-shadow: 10px 8px 21px 0px rgba(204, 204, 204, 0.75);
  -webkit-box-shadow: 10px 8px 21px 0px rgba(204, 204, 204, 0.75);
  -moz-box-shadow: 10px 8px 21px 0px rgba(204, 204, 204, 0.75);
}
#title-container h2 {
  font-size: 45px;
  font-weight: 800;
  color: #fff;
  padding: 0;
  margin-bottom: 0px;
}
#title-container h3 {
  font-size: 25px;
  font-weight: 600;
  color: #82000a;
  padding: 0;
}
#title-container p {
  font-size: 13px;
  padding: 0 25px;
  line-height: 20px;
}
.bic-image {
  width: 214px;
  margin-bottom: 15px;
}

/* FORMS */
#qbox-container {
  background-color: var(--bs-bw2-color);
  position: relative;
  padding: 40px;
  min-height: 630px;
  box-shadow: 10px 8px 21px 0px rgba(204, 204, 204, 0.75);
  -webkit-box-shadow: 10px 8px 21px 0px rgba(204, 204, 204, 0.75);
  -moz-box-shadow: 10px 8px 21px 0px rgba(204, 204, 204, 0.75);
}
#steps-container {
  margin: auto;
  width: 100%;
  min-height: 420px;
  /* display: flex;
  vertical-align: middle;
  align-items: center; */
}
.step {
  display: none;
}
.step h4 {
  margin: 0 0 26px 0;
  padding: 0;
  position: relative;
  font-weight: 500;
  font-size: 23px;
  font-size: 1.4375rem;
  line-height: 1.6;
}
button#prev-btn, button#next-btn, button#submit-btn,button#preview-btn {
  font-size: 17px;
  font-weight: bold;
  position: relative;
  width: 130px;
  height: 50px;
  background: var(--bs-primary);
  margin: 0 auto;
  margin-top: 40px;
  overflow: hidden;
  z-index: 1;
  cursor: pointer;
  transition: color .3s;
  text-align: center;
  color: #fff;
  border: 0;
  -webkit-border-bottom-right-radius: 5px;
  -webkit-border-bottom-left-radius: 5px;
  -moz-border-radius-bottomright: 5px;
  -moz-border-radius-bottomleft: 5px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
button#prev-btn:after, button#next-btn:after, button#submit-btn:after,button#preview-btn:after {
  position: absolute;
  top: 90%;
  left: 0;
  width: 100%;
  height: 100%;
  background: #cc0616;
  content: "";
  z-index: -2;
  transition: transform .3s;
}
button#prev-btn:hover::after, button#next-btn:hover::after, button#submit-btn:hover::after,button#preview-btn:hover::after {
  transform: translateY(-80%);
  transition: transform .3s;
}
.progress {
  border-radius: 0px !important;
}
.q__question {
  position: relative;
}
.q__question:not(:last-child) {
  margin-bottom: 10px;
}
.question__input {
  position: absolute;
  left: -9999px;
}
.question__label {
  position: relative;
  display: block;
  line-height: 40px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  background-color: #fff;
  padding: 5px 20px 5px 50px;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}
.question__label:hover {
  border-color: var(--bs-primary);
}
.question__label:before, .question__label:after {
  position: absolute;
  content: "";
}
.question__label:before {
  top: 12px;
  left: 10px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: inset 0 0 0 1px #ced4da;
  transition: all 0.15s ease-in-out;
}
.question__input:checked+.question__label:before {
  background-color: var(--bs-primary);
  box-shadow: 0 0 0 0;
}
.question__input:checked+.question__label:after {
  top: 22px;
  left: 18px;
  width: 10px;
  height: 5px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg);
}
.form-check-input:checked, .form-check-input:focus {
  /* background-color: var(--bs-primary) !important; 
  outline: none !important;
  border: none !important; */
}
input:focus {
  outline: none;
}
#input-container {
  display: inline-block;
  box-shadow: none !important;
  margin-top: 36px !important;
}
label.form-check-label.radio-lb {
  margin-right: 15px;
}
#q-box__buttons {
  text-align: right;
}
#textarea, .form-select, input[type="text"], input[type="email"],input[type="tel"],input[type="password"],input[type='file'] {
  padding: 8px 14px;
}
#textarea:focus,.form-select:focus,input[type="text"]:focus, input[type="email"]:focus, input[type="tel"]:focus, input[type="password"]:focus,input[type='file']:focus {
  border: 1px solid var(--bs-primary);
  border-radius: 5px;
  outline: 0px !important;
  -webkit-appearance: none;
  box-shadow: none !important;
  transition: all 0.15s ease-in-out;
}
.form-check-input:checked[type=radio], .form-check-input:checked[type=radio]:hover, .form-check-input:checked[type=radio]:focus, .form-check-input:checked[type=radio]:active {
  border: none !important;
  -webkit-outline: 0px !important;
  box-shadow: none !important;
}
.form-check-input:focus, input[type="radio"]:hover {
  box-shadow: none;
  cursor: pointer !important;
}
#success {
  display: none;
}
#success h4 {
  color: var(--bs-primary);
}
.back-link {
  font-weight: 700;
  color: var(--bs-primary);
  text-decoration: none;
  font-size: 18px;
}
.back-link:hover {
  color: #82000a;
}

/* PRELOADER */
#preloader-wrapper {
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: none;
  position: fixed;
  top: 0;
  left: 0;
}
#preloader {
  /* background-image: url('../img/preloader.png'); */
  width: 120px;
  height: 119px;
  border-top-color: #fff;
  border-radius: 100%;
  display: block;
  position: relative;
  top: 50%;
  left: 50%;
  margin: -75px 0 0 -75px;
  animation: spin 2s linear infinite;
  z-index: 1001;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
#preloader-wrapper .preloader-section {
  width: 51%;
  height: 100%;
  position: fixed;
  top: 0;
  background: #F7F9FF;
  z-index: 1000;
}
#preloader-wrapper .preloader-section.section-left {
  left: 0
}
#preloader-wrapper .preloader-section.section-right {
  right: 0;
}
.loaded #preloader-wrapper .preloader-section.section-left {
  transform: translateX(-100%);
  transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
}
.loaded #preloader-wrapper .preloader-section.section-right {
  transform: translateX(100%);
  transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
}
.loaded #preloader {
  opacity: 0;
  transition: all 0.3s ease-out;
}
.loaded #preloader-wrapper {
  visibility: hidden;
  transform: translateY(-100%);
  transition: all 0.3s 1s ease-out;
}

/* MEDIA QUERIES */
@media (min-width: 990px) and (max-width: 1199px) {
  #title-container {
    padding: 80px 28px 28px 28px;
  }
  #steps-container {
    width: 85%;
  }
}
@media (max-width: 991px) {
  #title-container {
    padding: 30px;
    min-height: inherit;
  }
}
@media (max-width: 767px) {
  #qbox-container {
    padding: 30px;
  }
  #steps-container {
    width: 100%;
    min-height: 400px;
  }
  #title-container {
    padding-top: 50px;
  }
}
@media (max-width: 560px) {
  #qbox-container {
    padding: 40px;
  }
  #title-container {
    padding-top: 45px;
  }
}




[dir=rtl] .floating-label > input + label,
[dir=rtl] .floating-label > textarea + label {
  right: 0;
  left: auto !important;
}
[dir=rtl] .floating-label > input:not([placeholder]):not([value]) + label,
[dir=rtl] .floating-label > textarea:not([placeholder]):empty + label, [dir=rtl] .floating-label > input[placeholder]:not(:placeholder-shown) + label,
[dir=rtl] .floating-label > textarea[placeholder]:not(:placeholder-shown) + label, [dir=rtl] .floating-label > input:-webkit-autofill + label,
[dir=rtl] .floating-label > textarea:-webkit-autofill + label, [dir=rtl] .floating-label > input:focus + label,
[dir=rtl] .floating-label > textarea:focus + label, [dir=rtl] .floating-label > select + label {
  right: 0.5rem;
  left: auto !important;
}

.floating-label {
  position: relative;
}
.floating-label > select + label {
  position: absolute;
  z-index: 3;
  max-width: calc(100% - 2px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  left: 0.5rem;
  padding: 0 0.3rem;
  line-height: 1.25;
  color: inherit;
  background-color: var(--bs-bw-color);
  border-radius: 0.375rem;
}
.floating-label > select + label,
.floating-label > select + label.label-sm {
  top: -0.5rem;
  left:15px;
  font-size: 0.875rem;
}
.floating-label > select + label.label-md {
  top: -0.75rem;
  font-size: 1rem;
}
.floating-label > select + label.label-lg {
  top: -0.9375rem;
  font-size: 1.25rem;
}
.floating-label > input + label,
.floating-label > textarea + label {
  position: absolute;
  z-index: 3;
  max-width: calc(100% - 2px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  top: 8px;
  left: 8px;
  font-size: 1rem;
  padding: 0.375rem 0.75rem;
  color: #6c757d;
  pointer-events: none;
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.floating-label > input.form-control-sm + label,
.floating-label > textarea.form-control-sm + label {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
}
.floating-label > input.form-control-lg + label,
.floating-label > textarea.form-control-lg + label {
  font-size: 1.25rem;
  padding: 0.5rem 1rem;
}
.floating-label > input::placeholder,
.floating-label > textarea::placeholder {
  color: transparent;
  transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.floating-label > label + input::placeholder,
.floating-label > label + textarea::placeholder {
  color: #6c757d;
}
.floating-label > input:focus::placeholder,
.floating-label > textarea:focus::placeholder {
  color: #6c757d;
}
.floating-label > input:focus + label,
.floating-label > textarea:focus + label {
  position: absolute;
  z-index: 3;
  max-width: calc(100% - 2px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  left: 0.5rem;
  padding: 0 0.3rem;
  line-height: 1.25;
  color: inherit;
  background-color: var(--bs-bw-color);
  border-radius: 0.375rem;
}
.floating-label > input:focus + label,
.floating-label > input:focus + label.label-sm,
.floating-label > textarea:focus + label,
.floating-label > textarea:focus + label.label-sm {
  top: -0.65625rem;
  font-size: 0.875rem;
}
.floating-label > input:focus + label.label-md,
.floating-label > textarea:focus + label.label-md {
  top: -0.05rem;
  font-size: 1rem;
}
.floating-label > input:focus + label.label-lg,
.floating-label > textarea:focus + label.label-lg {
  top: -0.9375rem;
  font-size: 1.25rem;
}

.floating-label > input:-webkit-autofill + label,
.floating-label > textarea:-webkit-autofill + label {
  position: absolute;
  z-index: 3;
  max-width: calc(100% - 2px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  left: 0.5rem;
  padding: 0 0.3rem;
  line-height: 1.25;
  color: inherit;
  background-color: var(--bs-bw-color);
  border-radius: 0.375rem;
}
.floating-label > input:-webkit-autofill + label,
.floating-label > input:-webkit-autofill + label.label-sm,
.floating-label > textarea:-webkit-autofill + label,
.floating-label > textarea:-webkit-autofill + label.label-sm {
  top: -0.65625rem;
  font-size: 0.875rem;
}
.floating-label > input:-webkit-autofill + label.label-md,
.floating-label > textarea:-webkit-autofill + label.label-md {
  top: -0.75rem;
  font-size: 1rem;
}
.floating-label > input:-webkit-autofill + label.label-lg,
.floating-label > textarea:-webkit-autofill + label.label-lg {
  top: -0.9375rem;
  font-size: 1.25rem;
}

.floating-label > input[placeholder]:not(:placeholder-shown) + label,
.floating-label > textarea[placeholder]:not(:placeholder-shown) + label {
  position: absolute;
  z-index: 3;
  max-width: calc(100% - 2px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  left: 0.5rem;
  padding: 0 0.3rem;
  line-height: 1.25;
  color: inherit;
  background-color: var(--bs-bw-color);
  border-radius: 0.375rem;
}
.floating-label > input[placeholder]:not(:placeholder-shown) + label,
.floating-label > input[placeholder]:not(:placeholder-shown) + label.label-sm,
.floating-label > textarea[placeholder]:not(:placeholder-shown) + label,
.floating-label > textarea[placeholder]:not(:placeholder-shown) + label.label-sm {
  top: -0.65625rem;
  font-size: 0.875rem;
}
.floating-label > input[placeholder]:not(:placeholder-shown) + label.label-md,
.floating-label > textarea[placeholder]:not(:placeholder-shown) + label.label-md {
  top: -0.75rem;
  font-size: 1rem;
}
.floating-label > input[placeholder]:not(:placeholder-shown) + label.label-lg,
.floating-label > textarea[placeholder]:not(:placeholder-shown) + label.label-lg {
  top: -0.9375rem;
  font-size: 1.25rem;
}
.floating-label > input:not([placeholder]):not([value]) + label,
.floating-label > textarea:not([placeholder]):empty + label {
  position: absolute;
  z-index: 3;
  max-width: calc(100% - 2px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  left: 0.5rem;
  padding: 0 0.3rem;
  line-height: 1.25;
  color: inherit;
  background-color: var(--bs-bw-color);
  border-radius: 0.375rem;
}
.floating-label > input:not([placeholder]):not([value]) + label,
.floating-label > input:not([placeholder]):not([value]) + label.label-sm,
.floating-label > textarea:not([placeholder]):empty + label,
.floating-label > textarea:not([placeholder]):empty + label.label-sm {
  top: -0.65625rem;
  font-size: 0.875rem;
}
.floating-label > input:not([placeholder]):not([value]) + label.label-md,
.floating-label > textarea:not([placeholder]):empty + label.label-md {
  top: -0.75rem;
  font-size: 1rem;
}
.floating-label > input:not([placeholder]):not([value]) + label.label-lg,
.floating-label > textarea:not([placeholder]):empty + label.label-lg {
  top: -0.9375rem;
  font-size: 1.25rem;
}

.input-group > .floating-label {
  flex: 1 1;
}
.input-group > .floating-label > .form-control,
.input-group > .floating-label > .form-select {
  position: relative;
}
.input-group > .floating-label > .form-control:focus,
.input-group > .floating-label > .form-select:focus {
  z-index: 3;
}
.input-group > .floating-label:not(:first-child) > .form-control,
.input-group > .floating-label:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .floating-label:not(:last-child) > .form-control,
.input-group > .floating-label:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/setup.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,uDAAuD;EACvD,+DAA+D;EAC/D,4DAA4D;AAC9D;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,uDAAuD;EACvD,+DAA+D;EAC/D,4DAA4D;AAC9D;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB;;wBAEsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,uCAAuC;EACvC,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;EAInC,iCAAiC;AACnC;AACA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE;;4BAE0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAI3B,iCAAiC;AACnC;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;AACT;AACA;EACE,mDAAmD;EACnD,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,uBAAuB;EAEvB,kCAAkC;EAClC,aAAa;AACf;AAaA;EACE;IAGE,uBAAuB;EACzB;EACA;IAGE,yBAAyB;EAC3B;AACF;AACA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,MAAM;EACN,mBAAmB;EACnB,aAAa;AACf;AACA;EACE;AACF;AACA;EACE,QAAQ;AACV;AACA;EACE,4BAA4B;EAC5B,kEAAkE;AACpE;AACA;EACE,2BAA2B;EAC3B,kEAAkE;AACpE;AACA;EACE,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;;;;;AAKA;;EAEE,QAAQ;EACR,qBAAqB;AACvB;AACA;;;;;EAKE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;AACA;;EAEE,YAAY;EACZ,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,kDAAkD;AACpD;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;EAClB,oDAAoD;AACtD;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;AACA;;;;EAIE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;AACA;;;;EAIE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;AACA;;;;EAIE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;AACA;;;;EAIE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B","sourcesContent":["\np {\n  margin-bottom: 24px;\n  line-height: 1.9;\n}\n\n#title-container {\n  min-height: 460px;\n  height: 100%;\n  color: #fff;\n  background-color: var(--bs-primary); \n  text-align: center;\n  padding: 105px 28px 28px 28px;\n  box-sizing: border-box;\n  position: relative;\n  box-shadow: 10px 8px 21px 0px rgba(204, 204, 204, 0.75);\n  -webkit-box-shadow: 10px 8px 21px 0px rgba(204, 204, 204, 0.75);\n  -moz-box-shadow: 10px 8px 21px 0px rgba(204, 204, 204, 0.75);\n}\n#title-container h2 {\n  font-size: 45px;\n  font-weight: 800;\n  color: #fff;\n  padding: 0;\n  margin-bottom: 0px;\n}\n#title-container h3 {\n  font-size: 25px;\n  font-weight: 600;\n  color: #82000a;\n  padding: 0;\n}\n#title-container p {\n  font-size: 13px;\n  padding: 0 25px;\n  line-height: 20px;\n}\n.bic-image {\n  width: 214px;\n  margin-bottom: 15px;\n}\n\n/* FORMS */\n#qbox-container {\n  background-color: var(--bs-bw2-color);\n  position: relative;\n  padding: 40px;\n  min-height: 630px;\n  box-shadow: 10px 8px 21px 0px rgba(204, 204, 204, 0.75);\n  -webkit-box-shadow: 10px 8px 21px 0px rgba(204, 204, 204, 0.75);\n  -moz-box-shadow: 10px 8px 21px 0px rgba(204, 204, 204, 0.75);\n}\n#steps-container {\n  margin: auto;\n  width: 100%;\n  min-height: 420px;\n  /* display: flex;\n  vertical-align: middle;\n  align-items: center; */\n}\n.step {\n  display: none;\n}\n.step h4 {\n  margin: 0 0 26px 0;\n  padding: 0;\n  position: relative;\n  font-weight: 500;\n  font-size: 23px;\n  font-size: 1.4375rem;\n  line-height: 1.6;\n}\nbutton#prev-btn, button#next-btn, button#submit-btn,button#preview-btn {\n  font-size: 17px;\n  font-weight: bold;\n  position: relative;\n  width: 130px;\n  height: 50px;\n  background: var(--bs-primary);\n  margin: 0 auto;\n  margin-top: 40px;\n  overflow: hidden;\n  z-index: 1;\n  cursor: pointer;\n  transition: color .3s;\n  text-align: center;\n  color: #fff;\n  border: 0;\n  -webkit-border-bottom-right-radius: 5px;\n  -webkit-border-bottom-left-radius: 5px;\n  -moz-border-radius-bottomright: 5px;\n  -moz-border-radius-bottomleft: 5px;\n  border-bottom-right-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\nbutton#prev-btn:after, button#next-btn:after, button#submit-btn:after,button#preview-btn:after {\n  position: absolute;\n  top: 90%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #cc0616;\n  content: \"\";\n  z-index: -2;\n  transition: transform .3s;\n}\nbutton#prev-btn:hover::after, button#next-btn:hover::after, button#submit-btn:hover::after,button#preview-btn:hover::after {\n  transform: translateY(-80%);\n  transition: transform .3s;\n}\n.progress {\n  border-radius: 0px !important;\n}\n.q__question {\n  position: relative;\n}\n.q__question:not(:last-child) {\n  margin-bottom: 10px;\n}\n.question__input {\n  position: absolute;\n  left: -9999px;\n}\n.question__label {\n  position: relative;\n  display: block;\n  line-height: 40px;\n  border: 1px solid #ced4da;\n  border-radius: 5px;\n  background-color: #fff;\n  padding: 5px 20px 5px 50px;\n  cursor: pointer;\n  transition: all 0.15s ease-in-out;\n}\n.question__label:hover {\n  border-color: var(--bs-primary);\n}\n.question__label:before, .question__label:after {\n  position: absolute;\n  content: \"\";\n}\n.question__label:before {\n  top: 12px;\n  left: 10px;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background-color: #fff;\n  box-shadow: inset 0 0 0 1px #ced4da;\n  -webkit-transition: all 0.15s ease-in-out;\n  -moz-transition: all 0.15s ease-in-out;\n  -o-transition: all 0.15s ease-in-out;\n  transition: all 0.15s ease-in-out;\n}\n.question__input:checked+.question__label:before {\n  background-color: var(--bs-primary);\n  box-shadow: 0 0 0 0;\n}\n.question__input:checked+.question__label:after {\n  top: 22px;\n  left: 18px;\n  width: 10px;\n  height: 5px;\n  border-left: 2px solid #fff;\n  border-bottom: 2px solid #fff;\n  transform: rotate(-45deg);\n}\n.form-check-input:checked, .form-check-input:focus {\n  /* background-color: var(--bs-primary) !important; \n  outline: none !important;\n  border: none !important; */\n}\ninput:focus {\n  outline: none;\n}\n#input-container {\n  display: inline-block;\n  box-shadow: none !important;\n  margin-top: 36px !important;\n}\nlabel.form-check-label.radio-lb {\n  margin-right: 15px;\n}\n#q-box__buttons {\n  text-align: right;\n}\n#textarea, .form-select, input[type=\"text\"], input[type=\"email\"],input[type=\"tel\"],input[type=\"password\"],input[type='file'] {\n  padding: 8px 14px;\n}\n#textarea:focus,.form-select:focus,input[type=\"text\"]:focus, input[type=\"email\"]:focus, input[type=\"tel\"]:focus, input[type=\"password\"]:focus,input[type='file']:focus {\n  border: 1px solid var(--bs-primary);\n  border-radius: 5px;\n  outline: 0px !important;\n  -webkit-appearance: none;\n  box-shadow: none !important;\n  -webkit-transition: all 0.15s ease-in-out;\n  -moz-transition: all 0.15s ease-in-out;\n  -o-transition: all 0.15s ease-in-out;\n  transition: all 0.15s ease-in-out;\n}\n.form-check-input:checked[type=radio], .form-check-input:checked[type=radio]:hover, .form-check-input:checked[type=radio]:focus, .form-check-input:checked[type=radio]:active {\n  border: none !important;\n  -webkit-outline: 0px !important;\n  box-shadow: none !important;\n}\n.form-check-input:focus, input[type=\"radio\"]:hover {\n  box-shadow: none;\n  cursor: pointer !important;\n}\n#success {\n  display: none;\n}\n#success h4 {\n  color: var(--bs-primary);\n}\n.back-link {\n  font-weight: 700;\n  color: var(--bs-primary);\n  text-decoration: none;\n  font-size: 18px;\n}\n.back-link:hover {\n  color: #82000a;\n}\n\n/* PRELOADER */\n#preloader-wrapper {\n  width: 100%;\n  height: 100%;\n  z-index: 1000;\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n#preloader {\n  /* background-image: url('../img/preloader.png'); */\n  width: 120px;\n  height: 119px;\n  border-top-color: #fff;\n  border-radius: 100%;\n  display: block;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  margin: -75px 0 0 -75px;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n  z-index: 1001;\n}\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n#preloader-wrapper .preloader-section {\n  width: 51%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  background: #F7F9FF;\n  z-index: 1000;\n}\n#preloader-wrapper .preloader-section.section-left {\n  left: 0\n}\n#preloader-wrapper .preloader-section.section-right {\n  right: 0;\n}\n.loaded #preloader-wrapper .preloader-section.section-left {\n  transform: translateX(-100%);\n  transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);\n}\n.loaded #preloader-wrapper .preloader-section.section-right {\n  transform: translateX(100%);\n  transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);\n}\n.loaded #preloader {\n  opacity: 0;\n  transition: all 0.3s ease-out;\n}\n.loaded #preloader-wrapper {\n  visibility: hidden;\n  transform: translateY(-100%);\n  transition: all 0.3s 1s ease-out;\n}\n\n/* MEDIA QUERIES */\n@media (min-width: 990px) and (max-width: 1199px) {\n  #title-container {\n    padding: 80px 28px 28px 28px;\n  }\n  #steps-container {\n    width: 85%;\n  }\n}\n@media (max-width: 991px) {\n  #title-container {\n    padding: 30px;\n    min-height: inherit;\n  }\n}\n@media (max-width: 767px) {\n  #qbox-container {\n    padding: 30px;\n  }\n  #steps-container {\n    width: 100%;\n    min-height: 400px;\n  }\n  #title-container {\n    padding-top: 50px;\n  }\n}\n@media (max-width: 560px) {\n  #qbox-container {\n    padding: 40px;\n  }\n  #title-container {\n    padding-top: 45px;\n  }\n}\n\n\n\n\n[dir=rtl] .floating-label > input + label,\n[dir=rtl] .floating-label > textarea + label {\n  right: 0;\n  left: auto !important;\n}\n[dir=rtl] .floating-label > input:not([placeholder]):not([value]) + label,\n[dir=rtl] .floating-label > textarea:not([placeholder]):empty + label, [dir=rtl] .floating-label > input[placeholder]:not(:placeholder-shown) + label,\n[dir=rtl] .floating-label > textarea[placeholder]:not(:placeholder-shown) + label, [dir=rtl] .floating-label > input:-webkit-autofill + label,\n[dir=rtl] .floating-label > textarea:-webkit-autofill + label, [dir=rtl] .floating-label > input:focus + label,\n[dir=rtl] .floating-label > textarea:focus + label, [dir=rtl] .floating-label > select + label {\n  right: 0.5rem;\n  left: auto !important;\n}\n\n.floating-label {\n  position: relative;\n}\n.floating-label > select + label {\n  position: absolute;\n  z-index: 3;\n  max-width: calc(100% - 2px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  left: 0.5rem;\n  padding: 0 0.3rem;\n  line-height: 1.25;\n  color: inherit;\n  background-color: var(--bs-bw-color);\n  border-radius: 0.375rem;\n}\n.floating-label > select + label,\n.floating-label > select + label.label-sm {\n  top: -0.5rem;\n  left:15px;\n  font-size: 0.875rem;\n}\n.floating-label > select + label.label-md {\n  top: -0.75rem;\n  font-size: 1rem;\n}\n.floating-label > select + label.label-lg {\n  top: -0.9375rem;\n  font-size: 1.25rem;\n}\n.floating-label > input + label,\n.floating-label > textarea + label {\n  position: absolute;\n  z-index: 3;\n  max-width: calc(100% - 2px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  top: 8px;\n  left: 8px;\n  font-size: 1rem;\n  padding: 0.375rem 0.75rem;\n  color: #6c757d;\n  pointer-events: none;\n  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n.floating-label > input.form-control-sm + label,\n.floating-label > textarea.form-control-sm + label {\n  font-size: 0.875rem;\n  padding: 0.25rem 0.5rem;\n}\n.floating-label > input.form-control-lg + label,\n.floating-label > textarea.form-control-lg + label {\n  font-size: 1.25rem;\n  padding: 0.5rem 1rem;\n}\n.floating-label > input::placeholder,\n.floating-label > textarea::placeholder {\n  color: transparent;\n  transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n.floating-label > label + input::placeholder,\n.floating-label > label + textarea::placeholder {\n  color: #6c757d;\n}\n.floating-label > input:focus::placeholder,\n.floating-label > textarea:focus::placeholder {\n  color: #6c757d;\n}\n.floating-label > input:focus + label,\n.floating-label > textarea:focus + label {\n  position: absolute;\n  z-index: 3;\n  max-width: calc(100% - 2px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  left: 0.5rem;\n  padding: 0 0.3rem;\n  line-height: 1.25;\n  color: inherit;\n  background-color: var(--bs-bw-color);\n  border-radius: 0.375rem;\n}\n.floating-label > input:focus + label,\n.floating-label > input:focus + label.label-sm,\n.floating-label > textarea:focus + label,\n.floating-label > textarea:focus + label.label-sm {\n  top: -0.65625rem;\n  font-size: 0.875rem;\n}\n.floating-label > input:focus + label.label-md,\n.floating-label > textarea:focus + label.label-md {\n  top: -0.05rem;\n  font-size: 1rem;\n}\n.floating-label > input:focus + label.label-lg,\n.floating-label > textarea:focus + label.label-lg {\n  top: -0.9375rem;\n  font-size: 1.25rem;\n}\n\n.floating-label > input:-webkit-autofill + label,\n.floating-label > textarea:-webkit-autofill + label {\n  position: absolute;\n  z-index: 3;\n  max-width: calc(100% - 2px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  left: 0.5rem;\n  padding: 0 0.3rem;\n  line-height: 1.25;\n  color: inherit;\n  background-color: var(--bs-bw-color);\n  border-radius: 0.375rem;\n}\n.floating-label > input:-webkit-autofill + label,\n.floating-label > input:-webkit-autofill + label.label-sm,\n.floating-label > textarea:-webkit-autofill + label,\n.floating-label > textarea:-webkit-autofill + label.label-sm {\n  top: -0.65625rem;\n  font-size: 0.875rem;\n}\n.floating-label > input:-webkit-autofill + label.label-md,\n.floating-label > textarea:-webkit-autofill + label.label-md {\n  top: -0.75rem;\n  font-size: 1rem;\n}\n.floating-label > input:-webkit-autofill + label.label-lg,\n.floating-label > textarea:-webkit-autofill + label.label-lg {\n  top: -0.9375rem;\n  font-size: 1.25rem;\n}\n\n.floating-label > input[placeholder]:not(:placeholder-shown) + label,\n.floating-label > textarea[placeholder]:not(:placeholder-shown) + label {\n  position: absolute;\n  z-index: 3;\n  max-width: calc(100% - 2px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  left: 0.5rem;\n  padding: 0 0.3rem;\n  line-height: 1.25;\n  color: inherit;\n  background-color: var(--bs-bw-color);\n  border-radius: 0.375rem;\n}\n.floating-label > input[placeholder]:not(:placeholder-shown) + label,\n.floating-label > input[placeholder]:not(:placeholder-shown) + label.label-sm,\n.floating-label > textarea[placeholder]:not(:placeholder-shown) + label,\n.floating-label > textarea[placeholder]:not(:placeholder-shown) + label.label-sm {\n  top: -0.65625rem;\n  font-size: 0.875rem;\n}\n.floating-label > input[placeholder]:not(:placeholder-shown) + label.label-md,\n.floating-label > textarea[placeholder]:not(:placeholder-shown) + label.label-md {\n  top: -0.75rem;\n  font-size: 1rem;\n}\n.floating-label > input[placeholder]:not(:placeholder-shown) + label.label-lg,\n.floating-label > textarea[placeholder]:not(:placeholder-shown) + label.label-lg {\n  top: -0.9375rem;\n  font-size: 1.25rem;\n}\n.floating-label > input:not([placeholder]):not([value]) + label,\n.floating-label > textarea:not([placeholder]):empty + label {\n  position: absolute;\n  z-index: 3;\n  max-width: calc(100% - 2px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  left: 0.5rem;\n  padding: 0 0.3rem;\n  line-height: 1.25;\n  color: inherit;\n  background-color: var(--bs-bw-color);\n  border-radius: 0.375rem;\n}\n.floating-label > input:not([placeholder]):not([value]) + label,\n.floating-label > input:not([placeholder]):not([value]) + label.label-sm,\n.floating-label > textarea:not([placeholder]):empty + label,\n.floating-label > textarea:not([placeholder]):empty + label.label-sm {\n  top: -0.65625rem;\n  font-size: 0.875rem;\n}\n.floating-label > input:not([placeholder]):not([value]) + label.label-md,\n.floating-label > textarea:not([placeholder]):empty + label.label-md {\n  top: -0.75rem;\n  font-size: 1rem;\n}\n.floating-label > input:not([placeholder]):not([value]) + label.label-lg,\n.floating-label > textarea:not([placeholder]):empty + label.label-lg {\n  top: -0.9375rem;\n  font-size: 1.25rem;\n}\n\n.input-group > .floating-label {\n  flex: 1;\n}\n.input-group > .floating-label > .form-control,\n.input-group > .floating-label > .form-select {\n  position: relative;\n}\n.input-group > .floating-label > .form-control:focus,\n.input-group > .floating-label > .form-select:focus {\n  z-index: 3;\n}\n.input-group > .floating-label:not(:first-child) > .form-control,\n.input-group > .floating-label:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .floating-label:not(:last-child) > .form-control,\n.input-group > .floating-label:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
